<template>
	<div class="help-page-container">
		<div class="help-page-title">
			{{title}}
		</div>
		<div class="help-page-box">
			<div>
				<div @click="c()">动画</div>
				
			</div>
			<div v-if="showM" class="help-info">
				hahahahaha
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'HelpPage',
		data(){
			return{
				showM: false,
				title:'聊天后台数据异常问题',
				content:`功能开发中，敬请期待。。`
			}
		},
		methods:{
			c(){
				this.showM = !this.showM
			}
		}
	}
</script>

<style>
	.help-page-container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.help-page-container .help-page-title{
		height: 50px;
		line-height: 50px;
		padding: 0 20px;
		border-bottom: 1px solid #E1E1E1;
		font-weight: 600;
	}
	.help-page-container .help-page-box{
		position: absolute;
		top: 51px;
		bottom: 0;
		left: 0;
		right: 0;
		overflow-x: hidden;
		overflow-y: auto;
		padding: 20px;
		line-height: 26px;
	}
	.help-page-box img{
		max-width: 100%;
	}
	.help-info{
		height: 0;
		background-color: #01AAED;
		animation-name: boxshow;
		animation-duration: .1s;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}
	@keyframes boxshow{
		from{
			height: 0;
		}
		to{
			height: 60px;
		}
	}
</style>
